export const SELECTION_BAR = {
  CLEAR: 'Limpiar',
}

export const TABLE_COMPONENT_TEXTS = {
  NO_ROWS: 'Sin filas',
  TOOLBAR_DENSITY: 'Densidad',
  TOOLBAR_EXPORT: 'Exportar',
  TABLE_PAGINATION: {
    LABEL_ROWS_PER_PAGE: 'Filas por página',
    LABEL_DISPLAYED_ROWS: ({ from, to, count }: { from: number; to: number; count: number }) =>
      `${from}–${to} de ${count !== -1 ? count : `más de ${to}`}`,
    GO_TO_FIRST_PAGE: 'Ir a la primera página',
    GO_TO_PREVIOUS_PAGE: 'Ir a la página anterior',
    GO_TO_NEXT_PAGE: 'Ir a la página siguiente',
    GO_TO_LAST_PAGE: 'Ir a la última página',
  },
}
